import React from 'react';

export const PreviewIndicator: React.FC = () => (
  <div className="fixed top-4 right-4 z-[9999]">
    <div className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow-lg flex items-center space-x-2">
      <span className="w-2 h-2 bg-white rounded-full animate-pulse"></span>
      <span className="text-sm font-medium">PREVIEW MODE</span>
      <button
        onClick={() => window.close()}
        className="text-white hover:text-gray-200 ml-2"
        title="Close Preview"
      >
        ×
      </button>
    </div>
  </div>
);
